export const defaultDomainLp = 
    {
        "localhost" : "LUFP_V5",
        "dev.unfairfinance.co.uk" : "LUFP_V5N1_1A",
        "pre.unfairfinance.co.uk" : "LUFP_V5N1_1A",
        "www.unfairfinance.co.uk" : "LUFP_V5N1_1A",
        "unfairfinance.co.uk" : "LUFP_V5N1_1A",
        "dev.lookupfinance.co.uk" : "LUFP_V5N1",
        "pre.lookupfinance.co.uk" : "LUFP_V5N1",
        "www.lookupfinance.co.uk" : "LUFP_V5N1",
        "lookupfinance.co.uk" : "LUFP_V5N1",
        "dev.scanandclaim.co.uk" : "LUFP_V5N1",
        "pre.scanandclaim.co.uk" : "LUFP_V5N1",
        "www.scanandclaim.co.uk" : "LUFP_V5N1",
        "scanandclaim.co.uk" : "LUFP_V5N1",
        "dev.myreclaim.co.uk" : "LUFP_V7A",
        "pre.myreclaim.co.uk" : "LUFP_V7A",
        "www.myreclaim.co.uk" : "LUFP_V7A",
        "myreclaim.co.uk" : "LUFP_V7A",
        // "dev.unfairfinance.co.uk" : "LUFP_V5N1_1C",
        // "pre.unfairfinance.co.uk" : "LUFP_V5N1_1C",
        // "www.unfairfinance.co.uk" : "LUFP_V5N1_1C",
        // "unfairfinance.co.uk" : "LUFP_V5N1_1C",
        // "dev.myreclaim.co.uk" : "LUFP_V5N1_1C",
        // "pre.myreclaim.co.uk" : "LUFP_V5N1_1C",
        // "www.myreclaim.co.uk" : "LUFP_V5N1_1C",
        // "myreclaim.co.uk" : "LUFP_V5N1_1C",
    }

